// List Collapsable


var fn_list_collapsable = function () {

  // Toggle Extra hidden DIV that holds a list of items (cards)
  var myToggler = $('.list-collapsable__toggler');

  myToggler.each(function () {
      $(this).on('click', function (e) {
        //
        $(this).css('outline','dashed 3px lime');
        $(this).parent().addClass('d-none');
        $(this).parent().next('.list-collapsable__wrapper').collapse('show');
        $(this).parent().next('.list-collapsable__wrapper').children().find('.card__wrapper').first().children('.card__trigger').focus();
      //
      });
  });

};
